// src/components/home/PortfolioHighlightSection.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PortfolioHighlightSection.css';
import pb from '../../lib/pocketbase';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function pbFileUrl(record, fileField, thumb) {
  try {
    if (!record || !record[fileField]) return '';
    return pb.files.getUrl(record, record[fileField], thumb ? { thumb } : undefined);
  } catch {
    return '';
  }
}

function PortfolioHighlightSection() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const loadProjects = async () => {
      try {
        // On récupère les 10 derniers projets publiés
        const res = await pb.collection('site_realisations').getList(1, 10, {
          sort: '-published_at,-created',
          filter: 'is_published = true',
          expand: 'category_id'
        });
        if (mounted) {
          setProjects(res.items);
          setLoading(false);
        }
      } catch (err) {
        console.error("Erreur chargement projets highlight:", err);
        if (mounted) setLoading(false);
      }
    };

    loadProjects();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return <section className="portfolio-highlight-container" style={{ minHeight: 400 }}></section>;
  }

  if (projects.length === 0) {
    return null; // Ou afficher un message vide
  }

  return (
    <section className="portfolio-highlight-container">
      <h2 className="section-title">Quelques-unes de nos réalisations</h2>
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={32}
        slidesPerView={1}
        loop={projects.length > 2} // Loop seulement s'il y a assez de slides
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          650: { slidesPerView: 1.2 },
          900: { slidesPerView: 2 },
        }}
        className="highlight-projects-swiper"
      >
        {projects.map((project) => {
          const coverUrl = pbFileUrl(project, 'cover_image', '800x600');
          const categoryName = project.expand?.category_id?.name || project.category || 'Réalisation';

          return (
            <SwiperSlide key={project.id} className="highlight-projects-slide">
              <div className="highlight-project-card">
                <Link to={`/realisations/${encodeURIComponent(project.slug)}`} className="project-card-link">
                  {coverUrl ? (
                    <img src={coverUrl} alt={project.title} className="highlight-project-image" />
                  ) : (
                    <div className="highlight-project-image placeholder"></div>
                  )}
                  <div className="highlight-project-content">
                    <h3>{project.title}</h3>
                    <p className="project-category">{categoryName}</p>
                  </div>
                </Link>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="see-all-projects-link">
        <Link to="/realisations" className="btn btn-primary">Découvrir tous nos projets</Link>
      </div>
    </section>
  );
}

export default PortfolioHighlightSection;